export default {
    addTitle: 'organization_member_add_title',
    editTitle: 'organization_member_edit_title',
    generatePassword: 'account_generate_password_button',
    save: 'save_button',
    cancel: 'cancel_button',
};
